/* Free A3 print promo. Standalone on purpose: the page loads theme.min.js,
   so theme.js is not editable. Contract with the theme:
   - dispatch 'cart:build' -> theme rebuilds drawer, then fires 'cart:updated'
     ONLY if the change came from the theme's own quantity-changed handler.
     'cart:build' itself, and 'ajaxProduct:added' (add-to-cart), rebuild
     silently with no event. So this file never relies on 'cart:updated' to
     catch its own mutations or self-heal's mutations -- it drives its own
     refresh() explicitly after every mutation it makes, and again on every
     drawer open and on page load. (Corrected after final review; the
     original contract assumed cart:updated fired more broadly.)
   - 'cart:open' opens the drawer; 'drawerOpen.CartDrawer' fires on open
   - <html class="js-drawer-open"> while a drawer is open
   - no drawer-close event exists in theme.js (verified by grep), so there
     is no drawer-close refresh hook here */
(function() {
  var SECTION = 'freebie-picker';
  var mount = null;

  var busy = false;

  function root() {
    return mount ? mount.querySelector('[data-freebie-root]') : null;
  }

  function cartChange(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function(r) { if (!r.ok) throw r; return r; });
  }

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: { _freebie: 'true' }
      })
    }).then(function(r) { if (!r.ok) throw r; return r; });
  }

  function cartRemove(lineKey) {
    return cartChange(lineKey, 0);
  }

  function rebuildTheme() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  // Success tail for any mutation this file makes: sync the theme drawer,
  // clear busy, then pull fresh server truth into the picker.
  function afterMutation() {
    rebuildTheme();
    busy = false;
    return refresh();
  }

  // Failure tail for user-triggered mutations: still clear busy, and
  // re-sync the picker to whatever the server actually has (the optimistic
  // click may not have landed).
  function afterMutationFailed() {
    busy = false;
    return refresh();
  }

  function onMountClick(evt) {
    var addBtn = evt.target.closest('[data-freebie-add]');
    var removeBtn = evt.target.closest('[data-freebie-remove]');
    var changeBtn = evt.target.closest('[data-freebie-change]');
    if (!addBtn && !removeBtn && !changeBtn) return;
    if (busy) return;
    busy = true;

    if (addBtn) {
      cartAdd(addBtn.getAttribute('data-freebie-add'))
        .then(afterMutation, afterMutationFailed);
    } else if (removeBtn) {
      cartRemove(removeBtn.getAttribute('data-freebie-remove'))
        .then(afterMutation, afterMutationFailed);
    } else if (changeBtn) {
      // Change = remove current freebie; refresh then shows the picker again.
      var r = root();
      var key = r && r.getAttribute('data-freebie-key');
      if (!key) { busy = false; return; }
      cartRemove(key).then(afterMutation, afterMutationFailed);
    }
  }

  // If the cart stopped qualifying, duplicate freebie lines exist
  // (multi-tab), or the claimed line's quantity drifted above 1 (double
  // Choose merge, manual qty bump), normalize it. Without this, the
  // discount stops matching (or only covers one unit) and the customer
  // silently pays for the print.
  //
  // Termination: each pass only mutates when there is a removable key or a
  // quantity to normalize. Removing a key or fixing a quantity changes
  // server state such that the next server-rendered pass no longer sees
  // that condition, so the amount of removable/normalizable state strictly
  // decreases pass over pass until nothing is left and selfHeal returns
  // without mutating -- it cannot loop forever, and a clean cart mutates
  // nothing at all (the fast path out).
  function selfHeal() {
    var r = root();
    if (!r) return;

    var eligible = r.getAttribute('data-eligible') === 'true';
    var claimed = r.getAttribute('data-claimed') === 'true';
    var mainKey = r.getAttribute('data-freebie-key');
    var removeMain = !eligible && claimed;

    var keys = (r.getAttribute('data-freebie-extra-keys') || '')
      .split(',').filter(Boolean);
    if (removeMain) keys.push(mainKey);

    var qty = Number(r.getAttribute('data-freebie-qty'));
    var needsQtyFix = claimed && !removeMain && qty > 1;

    if (!keys.length && !needsQtyFix) return;
    if (busy) return;
    busy = true;

    var chain = keys.reduce(function(chain, key) {
      return chain.then(function() { return cartRemove(key); });
    }, Promise.resolve());

    if (needsQtyFix) {
      chain = chain.then(function() { return cartChange(mainKey, 1); });
    }

    chain.then(function() {
      rebuildTheme();
      busy = false;
      return refresh();
    }, function() {
      busy = false;
    });
  }

  var popupModal = null;

  function popupEl() {
    return document.querySelector('[data-freebie-popup]');
  }

  function getPopupModal(el) {
    if (!popupModal && window.theme && theme.Modals) {
      popupModal = new theme.Modals(el.id, 'freebie-popup-modal');
      el.addEventListener('click', function(evt) {
        if (evt.target.closest('[data-freebie-popup-cta]')) {
          popupModal.close();
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      });
      document.addEventListener('modalClose.' + el.id, function() {
        if (el.getAttribute('data-mode') !== 'testing' && window.Cookies) {
          Cookies.set('freebie-popup', 'dismissed', {
            path: '/',
            expires: Number(el.getAttribute('data-days')) || 7
          });
        }
      });
    }
    return popupModal;
  }

  // Spec rules: never once claimed; at most once per session. Plus: skip
  // while the drawer is open — the customer is already looking at the picker.
  function maybePopup() {
    var r = root();
    var el = popupEl();
    if (!r || !el) return;
    if (r.getAttribute('data-eligible') !== 'true') return;
    if (r.getAttribute('data-claimed') === 'true') return;
    var testing = el.getAttribute('data-mode') === 'testing';
    if (!testing) {
      if (sessionStorage.getItem('freebie-popup-shown')) return;
      if (window.Cookies && Cookies.get('freebie-popup')) return;
    }
    if (document.documentElement.classList.contains('js-drawer-open')) return;
    if (window.Shopify && Shopify.designMode) return;
    var modal = getPopupModal(el);
    if (!modal) return;
    modal.open();
    sessionStorage.setItem('freebie-popup-shown', '1');
  }

  function refresh() {
    if (!mount) return Promise.resolve();
    return fetch('/?sections=' + SECTION, { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(json) {
        if (json && typeof json[SECTION] === 'string') {
          mount.innerHTML = json[SECTION];
          selfHeal();
          maybePopup();
        }
      })
      .catch(function() { /* failed fetch leaves DOM untouched */ });
  }

  document.addEventListener('DOMContentLoaded', function() {
    mount = document.querySelector('[data-freebie-mount]');
    if (!mount) return;
    mount.addEventListener('click', onMountClick);

    // Refresh on every drawer open: cheap when the picker is already
    // current, and it's the popup's other firing moment (unlock while the
    // drawer is already closed and reopened later).
    document.addEventListener('drawerOpen.CartDrawer', function() {
      refresh();
    });

    // Covers quantity changes made through the theme's own qty controls,
    // the one case where the theme does dispatch this event itself.
    document.addEventListener('cart:updated', function() {
      refresh();
    });

    document.addEventListener('shopify:section:select', function(evt) {
      var el = popupEl();
      if (el && evt.target.contains(el)) {
        var m = getPopupModal(el);
        if (m) m.open();
      }
    });
    document.addEventListener('shopify:section:deselect', function(evt) {
      var el = popupEl();
      if (el && evt.target.contains(el) && popupModal) popupModal.close();
    });

    // Page-load sync: catches carts left in a bad state from a previous
    // session (self-heal), and gives the popup its firing moment on pages
    // where the drawer is never opened.
    refresh();
  });

  window.__freebieRefresh = refresh; // manual testing hook
})();
